import React from 'react';

import ElementConstants from '../../../../shared/constants/elements';

import InputLabel from '../../widgets/input-label';
import InputHint from '../../widgets/input-hint';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';

export default class RatingElement extends React.Component {
	render() {
		const localization = new Localization(window.edlio.localizations);

		const {
			fieldsetIndex,
			rowIndex,
			index,
			usePlaceholderLabel
		} = this.props;

		const {
			label,
			hint,
			description,
			required
		} = this.props.data;

		return (
			<div className='rating input-group'>
				<header>
					<InputLabel ref='label' label={label} required={required} usePlaceholderLabel={usePlaceholderLabel} />
					<InputHint ref='hint' hint={hint} />
				</header>
				{localization.localize('Rating')}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/input-groups/rating.js